import * as React from 'react';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { BadgeList } from 'ui/badge-list';
import { MdGroup } from 'react-icons/md';
import { ComponentProps } from 'ui/common';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { ChildEntityCountShape } from 'app/area/case/selectors';
import { isCaseViewModalOpen } from 'app/components/helpers';

interface FactItemInvolvedPersonProps extends ComponentProps, FactItemProps {
  numberOfInvolvedPersons: ChildEntityCountShape;
}

export const InvolvedPersonFactItem = (props: FactItemInvolvedPersonProps) => {
  const { tooltip, title, numberOfInvolvedPersons, url, linkDomain, portalTarget } = props;
  const iconInvolvedPersons = <MdGroup />;
  const items = [
    { value: numberOfInvolvedPersons?.count as number, tooltip }
  ];

  if (!numberOfInvolvedPersons?.count) {
    return null;
  }
  return <FactLink id={props.componentId} classNames="fact-item" section={linkDomain} url={url} skipNavigation={isCaseViewModalOpen()}>
    <BadgeList
      icon={iconInvolvedPersons}
      title={title}
      valueItems={items}
      portalTarget={portalTarget}
    />
  </FactLink>;
};

